import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Company panel → Shuru: the conversation dashboard and the employee list.
 * Shuru is the in-app AI companion, so this section reports reach and outcome
 * in aggregate; what anyone actually said to it is never surfaced.
 */
const CompanyShuruLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'Shuru Dashboard',
      path: `/${slug}/shuru`,
      description: 'Reach, conversations, how people felt and what they are carrying'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/shuru/users`,
      description: `Per-${population.replace(/s$/, '')} conversation records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Shuru"
      subtitle={`Your ${population} and the AI companion — who reaches out, when, and how they feel afterwards.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyShuruLayout;
